<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Merchant Name"
            label-for="v-name"
          >
            <b-form-input
              id="v-name"
              v-model="filters['name']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Merchant Business"
            label-for="merchant_business"
          >
            <v-select
              id="merchant_business"
              v-model="filters['business_id']"
              :options="merchantBusinessOptions"
              :reduce="option => option.id"
              label="business_name"
              placeholder="Select Merchant Business"
            >
              <template
                v-slot:option="option"
                class="text-truncate"
              >
                {{ option.business_name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Merchant Ref Number"
            label-for="ref-no"
          >
            <b-form-input
              id="ref-no"
              v-model="filters['ref_no']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Admin Name"
            label-for="v-ref-no"
          >
            <b-form-input
              id="v-ref-no"
              v-model="filters['admin_name']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Created At"
            label-for="created_at"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['created_at']"
                :opens="'right'"
                @update="updateDateRange('created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Active Status"
            label-for="active_status"
          >
            <v-select
              v-model="filters['is_active']"
              :options="statusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template
                v-slot:option="option"
                class="text-truncate"
              >
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Admin Email"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="filters['merchant_email']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Admin Contact Number"
            label-for="contact_no"
          >
            <b-form-input
              id="contact_no"
              v-model="filters['admin_phone']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Primary Business Contact Number"
            label-for="business_phone"
          >
            <b-form-input
              id="business_phone"
              v-model="filters['default_business_phone']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            v-if="canShowSalesPerson"
            label="Sales Person Name"
            label-for="v-name"
          >
            <b-form-input
              id="v-name"
              v-model="filters['sales_person_name']"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>

    <b-card no-body>
      <div>
        <div class="m-2">
          <!-- input -->
          <b-row>
            <b-col
              cols="8"
              class="d-flex align-items-center justify-content-start mt-1 mb-md-0"
            >
              <b-button
                v-can="'create-merchant'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="custom-button-color"
                @click="onClickOpenAddMerchantModal"
              >
                <feather-icon icon="PlusIcon" />
                Add New
              </b-button>
            </b-col>
            <b-col
              class="d-flex align-items-center justify-content-end mt-1 mb-1 mb-md-0"
            >
              <ReportTableButtons
                :items="rows"
                :json_fieldz="json_fields"
                :name="`Merchants - Page ${page}.xls`"
                :bulkname="`Merchants.xls`"
                :fetch="fetchMerchantListNoPagination"
                @refresh="onClickRefresh"
              />
            </b-col>
          </b-row>
        </div>

        <!-- table -->
        <b-overlay
          id="overlay-background"
          variant="light"
          opacity="0.30"
          blur="10px"
          rounded="sm"
        >
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="rows"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
            sticky-header="100vh"
            class="hide-vertical-scroll"
            @sort-changed="sortChanged"
          >
            <template #empty>
              <TableDataFetching
                :rows="rows"
                :data-loading="dataLoading"
              />
            </template>
            <template #head()="{ field }">
              <div class="sortable-header">
                <span class="header-text">{{ field.label }}</span>
                <feather-icon
                  v-if="field.sortable"
                  :icon="sort === field.key ? 'ArrowUpIcon' : 'ArrowDownIcon'"
                  size="14"
                />
              </div>
            </template>
            <template #cell(name)="data">
              <div class="d-flex align-items-center">
                <div>
                  <b-avatar
                    size="32"
                    :text="avatarText(data.item.name)"
                    variant="light-primary"
                  />
                </div>
                <div>
                  <div class="font-weight-bolder ml-1">
                    {{ `${data.item.name}${data.item.setting.merchant_type === 'cash' ? "&nbsp;[&nbsp;C&nbsp;]" : ''}` }}
                  </div>
                  <div class="font-weight-bold ml-1">
                    {{ data.item.ref_no }}
                  </div>
                  <div class="font-small-2 ml-1">
                    {{ timestampToDateTime(data.item.created_at) }}
                  </div>
                  <div class="ml-1">
                    <div v-if="data.item.is_active === 'active'">
                      <b-badge variant="light-success">
                        Active
                      </b-badge>
                    </div>
                    <div v-if="data.item.is_active === 'inactive'">
                      <b-badge variant="light-danger">
                        Inactive
                      </b-badge>
                    </div>
                    <div v-if="data.item.is_active === 'new'">
                      <b-badge variant="light-primary">
                        New
                      </b-badge>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(default_address)="data">
              <div v-if="data.value !== ''">
                <div class="d-flex align-items-center">
                  <div>
                    <div>
                      {{ data.value.address_line_1 }} {{ data.value.address_line_2 }}
                      {{ data.value.address_line_3 }}
                    </div>
                    <div class="font-weight-bolder">
                      {{ data.value.city.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="ml-4">
                  <span>---</span>
                </div>
              </div>
            </template>
            <template #cell(contact_no)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div class="font-weight-bolder">
                    {{ data.item.default_address ? data.item.default_address.default_contact_details.length > 0 ? data.item.default_address.default_contact_details[0].phone || 'N/A' : 'N/A' : 'N/A' }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(admin_details)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div class="font-weight-bolder">
                    {{ data.item.admin ? `${data.item.admin.first_name} ${data.item.admin.last_name}` : '' }}
                  </div>
                  <div>
                    {{ data.item.admin ? data.item.admin.email : '' }}
                  </div>
                  <div>
                    {{ data.item.admin ? data.item.admin.phone : '' }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(rate_card)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div class="font-weight-bolder">
                    <router-link
                      v-if="data.item.rate_card_id != null"
                      :to="{ name: 'view-rate-card', params: { rateCardType: 'merchant', id: data.item.rate_card_id } }"
                    >
                      {{ data.item.rate_card }}
                    </router-link>
                    <router-link
                      v-else
                      class="text-muted"
                      to=""
                    >
                      N/A
                    </router-link>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(created_at)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div class="font-weight-bolder ml-1">
                    {{ timestampToDateTime(data.item.created_at) }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(sales_person.name)="data">
              <div class="d-flex align-items-center">
                <div>
                  <div
                    :class="{
                      'font-weight-bolder': true,
                      'text-muted': !data.item.sales_person
                    }"
                  >
                    {{ data.item.sales_person ? data.item.sales_person.name : 'N/A' }}
                  </div>
                </div>
              </div>
            </template>

            <!-- Actions Dropdown -->
            <template #cell(action)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                :class="rows.length !== 1 ? 'dropdown-no-scroll':''"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-can="'show-merchant'"
                  @click="onClickOpenMerchant(data.item.id)"
                >
                  <div>
                    <feather-icon icon="ActivityIcon" />
                    Manage Merchant
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'edit-merchant'"
                  @click="onClickOpenMerchantAdmin(data.item.id, data.item.admin.id)"
                >
                  <feather-icon icon="UserIcon" />
                  Manage Merchant Admin
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'edit-merchant'"
                  @click="onClickOpenMerchantSettings(data.item.id)"
                >
                  <feather-icon icon="SettingsIcon" />
                  Manage Merchant Settings
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canEditSalesPerson"
                  @click="onClickOpenSalesInformation(data.item.id)"
                >
                  <feather-icon icon="BriefcaseIcon" />
                  Manage Sales Information
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'view-merchant-business'"
                  @click="onClickOpenMerchantBusinesses(data.item.id)"
                >
                  <feather-icon icon="TruckIcon" />
                  Manage Merchant Businesses
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'download-verification-document'"
                  @click="fetchVerificationDocuments(data.item.id)"
                >
                  <feather-icon icon="DownloadIcon" />
                  Download Documents
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'download-merchant-agreement-setting'"
                  @click="downloadMerchantAgreement(data.item.id, data.item.name)"
                >
                  <feather-icon icon="FileTextIcon" />
                  Download Agreement (PDF)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row cols="12">
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </div>
    </b-card>

    <create-merchant-modal ref="add_new_merchant_modal" />
    <update-merchant-modal ref="update_merchant_modal" />
    <update-merchant-settings-modal ref="update_merchant_settings_modal" />
    <update-merchant-user-modal ref="update_merchant_user_modal" />
    <third-party-integration-modal ref="third_party_integration_modal" />
    <update-sales-information-modal ref="update_sales_infromation_modal" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  BBadge,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import DOMPurify from 'dompurify'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import { timestampToDateTime } from '@core/utils/timeUtil'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'
import CreateMerchantModal from '@/components/merchant/CreateMerchantModal.vue'
import UpdateMerchantModal from '@/components/merchant/UpdateMerchantModal.vue'
import UpdateMerchantSettingsModal from '@/components/merchant/UpdateMerchantSettingsModal.vue'
import UpdateSalesInformationModal from '@/components/merchant/UpdateSalesInformationModal.vue'
import UpdateMerchantUserModal from '@/components/merchant/UpdateMerchantUserModal.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const MerchantRepository = RepositoryFactory.get('merchant')
const MerchantAgreementRepository = RepositoryFactory.get('merchantAgreement')

function initialState() {
  return {
    avatarText,
    timestampToDateTime,
    filters: {
      created_at: {
        startDate: null,
        endDate: null,
      },
    },
    total: 0,
    meta: {},
    dataLoading: false,
    sort: '',
    perPage: 20,
    pageOptions: [10, 20, 50],
    totalRows: 1,
    page: 1,
    sortBy: '',
    sortDesc: false,
    sortDirection: 'asc',
    statusOptions: [
      {
        name: 'Active',
        key: 'active',
      },
      {
        name: 'Inactive',
        key: 'inactive',
      },
      {
        name: 'New',
        key: 'new',
      },
    ],
    fields: [
      {
        key: 'id', label: 'Ref No', sortable: true, thClass: 'd-none', tdClass: 'd-none',
      },
      {
        key: 'name', label: 'Merchant', sortable: true, thClass: 'text-center',
      },
      {
        key: 'default_address', label: 'Primary Business Address', sortable: false, thClass: 'text-left',
      },
      {
        key: 'contact_no', label: 'Primary Business Contact', sortable: false, thClass: 'text-left',
      },
      {
        key: 'admin_details', label: 'Admin Details', sortable: false, thClass: 'text-left',
      },
      {
        key: 'rate_card', label: 'Rate Card ', sortable: false, thClass: 'text-left',
      },
      store.getters.permissions.filter(permission => permission === 'show-sales-person').length > 0 ? {
        key: 'sales_person.name', label: 'Sales Person', sortable: true, thClass: ' text-left',
      } : {},
      {
        key: 'action', label: 'Action', sortable: false, thClass: 'text-center',
      },
    ],
    json_fields: {
      REF: 'ref_no',
      'Merchant Name': {
        field: 'name',
        callback: value => `"${value}"`,
      },
      Active: 'is_active',
      'Primary Address': {
        callback: value => `"${value.default_address !== null ? `${value.default_address.address_line_1}` : 'N/A'} ${value.default_address !== null && value.default_address.address_line_2 !== null ? `${value.default_address.address_line_2}` : ''} ${value.default_address !== null && value.default_address.address_line_3 !== null ? `${value.default_address.address_line_3}` : ''} ${value.default_address !== null ? `${value.default_address.city.name}` : ''}"`,
      },
      'Primary Business Contact': {
        callback: value => `"${value.default_address !== null && value.default_address.default_contact_details.length > 0 ? value.default_address.default_contact_details[0].phone : 'N/A'}"`,
      },
      'Admin Name': {
        callback: value => `${value.admin ? `"${value.admin.first_name} ${value.admin.last_name}"` : ''}`,
      },
      'Admin Email': 'admin.email',
      'Admin Phone Number': 'admin.phone',
      'Rate Card': {
        field: 'rate_card',
        callback: value => `"${value}"`,
      },
      ...(store.getters.permissions.filter(permission => permission === 'show-sales-person').length > 0 ? {
        'Sales Person': {
          callback: value => `"${value.sales_person ? `${value.sales_person.name}` : 'N/A'}"`,
        },
      } : {}),
    },
    rows: [],
    merchantBusinessOptions: [],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    FilterCard,
    BPagination,
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BOverlay,
    vSelect,
    BDropdown,
    BDropdownItem,
    BBadge,
    BAvatar,
    CreateMerchantModal,
    UpdateMerchantModal,
    UpdateMerchantSettingsModal,
    UpdateMerchantUserModal,
    UpdateSalesInformationModal,
    AdvancedDateFilter,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return initialState()
  },
  computed: {
    canEditSalesPerson() {
      return store.getters.permissions.filter(permission => permission === 'edit-sales-person').length > 0
    },
    canShowSalesPerson() {
      return store.getters.permissions.filter(permission => permission === 'show-sales-person').length > 0
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    page() {
      this.fetchMerchantList()
    },
    perPage() {
      this.fetchMerchantList()
    },
  },
  mounted() {
    this.fetchMerchantList()
    this.fetchBusinessList()
    this.updateFilterCount()
  },
  methods: {
    onClickOpenAddMerchantModal() {
      this.$refs.add_new_merchant_modal.openModal()
    },
    onClickOpenMerchant(id) {
      this.$refs.update_merchant_modal.openModal(id)
    },
    onClickOpenMerchantAdmin(id, adminId) {
      this.$refs.update_merchant_user_modal.openModal(id, adminId, 'admin')
    },
    onClickOpenMerchantSettings(id) {
      this.$refs.update_merchant_settings_modal.openModal(id)
    },
    onClickOpenMerchantBusinesses(id) {
      this.$router.push({ name: 'merchant-details-management', params: { id } })
    },
    onClickOpenThirdPartyIntegration(id) {
      this.$refs.third_party_integration_modal.openModal(id)
    },
    onClickOpenSalesInformation(id) {
      this.$refs.update_sales_infromation_modal.openModal(id)
    },
    async fetchMerchantList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await MerchantRepository.getMerchantList(this.page, filterQuery, this.perPage))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchMerchantListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await MerchantRepository.getMerchantListNoPagination(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    applyFilters() {
      this.fetchMerchantList()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchMerchantList()
      })
      this.updateFilterCount()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchMerchantList()
    },
    changePage(value) {
      this.perPage = value
    },
    onClickRefresh() {
      this.fetchMerchantList()
    },
    async fetchBusinessList() {
      this.merchantBusinessOptions = localStorage.getItem('business_list') ? JSON.parse(localStorage.getItem('business_list')) : (await MerchantRepository.fetchBusinessList()).data.data
      if (!localStorage.getItem('business_list')) localStorage.setItem('business_list', JSON.stringify(this.merchantBusinessOptions))
    },
    async fetchVerificationDocuments(id) {
      try {
        const merchantId = id
        const response = (await MerchantRepository.fetchVerificationDocuments(merchantId))
        if (response.status === 200) {
          this.zip_url = response.data.data.zip_url
          this.downloadZip()
        } else {
          this.showErrorMessage('Error fetching documents', response.data.error)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    downloadZip() {
      if (this.zip_url) {
        const link = document.createElement('a')
        link.href = this.zip_url
        link.setAttribute('download', 'merchant_verification_documents.zip')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },

    async downloadMerchantAgreement(id, merchantName = '') {
      this.dataLoading = true
      try {
        // 1. Fetch the agreement from backend endpoint
        const response = await MerchantAgreementRepository.getMerchantAgreement(id)
        const agreementData = response.data && response.data.data ? response.data.data : response.data

        const {
          agreement_html: agreementHtml,
          merchant_ref: merchantRef = `MC-${id}`,
          document_name: documentName = 'MERCHANT-AGREEMENT',
          date = new Date().toISOString().split('T')[0],
        } = agreementData

        // 2. Retrieve Company Settings
        const storedSettings = localStorage.getItem('businessSettings')
        const courier = storedSettings ? JSON.parse(storedSettings) : {
          company_name: 'DEMO CURFOX',
          company_address: 'No 69 Subhadrarama Road, Katliya Junction',
          company_country: 'Sri Lanka',
          company_phone: '+94 11 234 5678',
        }

        // 3. Define 10px margin in mm (10px at 96 DPI ≈ 2.65mm)
        // NOTE: If you meant 10mm instead of 10px, change this to: const marginX = 10
        const marginX = 15

        // 4. Build the DOM Element (Set padding to 0 so it aligns strictly with the margins)
        const element = document.createElement('div')
        element.style.padding = '0 10px'
        element.style.fontFamily = 'Helvetica, Arial, sans-serif'
        element.style.color = '#2b2b2b'

        const cleanAgreementHtml = DOMPurify.sanitize(agreementHtml)

        element.innerHTML = `
        <style>
          .agreement-body {
            font-size: 14px;
            color: #2b2b2b;
          }
          .agreement-body p, 
          .agreement-body li, 
          .agreement-body span, 
          .agreement-body div {
            line-height: 1.2 !important;
            margin-bottom: 5px !important;
          }
        </style>
        <!-- Document Header Table -->
        <table style="width: 100%; border-bottom: 2px solid #cbd5e1; padding-bottom: 12px; margin-bottom: 20px;">
          <tr>
            <td style="text-align: left; vertical-align: top;">
              <div class="text-primary" style="font-size: 18px; font-weight: bold; margin-bottom: 4px;">
                ${courier.company_name || 'DEMO CURFOX'}
              </div>
              <div style="font-size: 12px; color: #64748b; line-height: 1.4;">
                ${courier.company_address || ''}<br>
                ${courier.company_country || ''}<br>
                ${courier.company_phone || ''}
              </div>
            </td>
            <td style="text-align: right; vertical-align: top; font-size: 12px; color: #334155; line-height: 1.4;">
              <div><strong>Merchant ID:</strong> ${merchantRef}</div>
              <div><strong>Document:</strong> ${documentName}</div>
              <div><strong>Date:</strong> ${date}</div>
            </td>
          </tr>
        </table>

        <!-- Agreement Body -->
        <div class="agreement-body">
          ${cleanAgreementHtml}
        </div>
      `

        // 5. Load html2pdf library
        const html2pdfModule = await import('html2pdf.js')
        const html2pdf = html2pdfModule.default || html2pdfModule

        // 6. PDF Options with marginX applied to left and right
        const cleanName = merchantName ? merchantName.replace(/[^a-zA-Z0-9_-]/g, '_') : merchantRef
        const opt = {
          margin: [15, 12, 20, 12], // [top, left, bottom, right]
          filename: `Merchant_Agreement_${cleanName}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, logging: false },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        }

        const localTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        const footerText = `Generated by ${courier.company_name || 'DEMO CURFOX'} Merchant Agreement Builder - ${date} ${localTime}`

        await html2pdf()
          .set(opt)
          .from(element)
          .toPdf()
          .get('pdf')
          .then(pdf => {
            const totalPages = pdf.internal.getNumberOfPages()
            const pageWidth = pdf.internal.pageSize.getWidth()
            const pageHeight = pdf.internal.pageSize.getHeight()

            for (let i = 1; i <= totalPages; i += 1) {
              pdf.setPage(i)

              // 1. Divider line spanning from marginX to (pageWidth - marginX)
              pdf.setDrawColor(226, 232, 240)
              pdf.setLineWidth(0.3)
              pdf.line(marginX, pageHeight - 12, pageWidth - marginX, pageHeight - 12)

              // 2. Footer Text styling
              pdf.setFontSize(8)
              pdf.setTextColor(148, 163, 184)

              // Left text starts at marginX
              pdf.text(footerText, marginX, pageHeight - 7)

              // Right page numbering ends at (pageWidth - marginX)
              const pageStr = `Page ${i} of ${totalPages}`
              pdf.text(pageStr, pageWidth - marginX, pageHeight - 7, { align: 'right' })
            }
          })
          .save()

        this.showSuccessMessage('Agreement PDF downloaded successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.dataLoading = false
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
.dropdown .dropdown-menu {
  max-height: 180px;
  overflow-y: auto;
}
</style>
